const Lang = require('lang');
const confirm = require('../events/confirm');
const GlobalAlerts = require('global_alerts');
const DetalhesLoteIntegracao = require('./DetalhesLoteIntegracao');
const FiltrarLotesEventosIntegracao = require('./FiltrarLotesEventosIntegracao');

function ExportarIntegracao() {
  nifty.body.overlay({
    fixed: true
  });
  const buttonSubmit = document.querySelector('.form-download-async');
  if (document.contains(buttonSubmit)) {
    buttonSubmit.addEventListener('click', clickHandler);
  }
}

/**
 * Adicionando o Event Listener
 *
 * @param  {event} event
 *
 * @return {void}
 */
function clickHandler(event) {
  const form = event.currentTarget.form;
  const partialLotes = document.querySelector('#content-partials-exported');

  if (!$(form).valid()) {
    return;
  }

  nifty.body.overlay('show');
  sendRequestFilter(event.currentTarget.form)
    .done(function(data) {
      GlobalAlerts.createAndShow({
        message: Lang.get('js/src/functions/ExportarIntegracao.download_initiated'),
      });
      partialLotes.innerHTML = data.data;
      confirm.init();
      // forceDownload(data.link);
      DetalhesLoteIntegracao.applyListeners();
      FiltrarLotesEventosIntegracao.initalizeInputsDate();
      FiltrarLotesEventosIntegracao.applyListenerFilter();
    })
    .fail(function(error) {
      const responseJSON = error.responseJSON;
      const typeAlert = (responseJSON.status === undefined)
        ? 'danger'
        : error.responseJSON.status;

      GlobalAlerts.createAndShow({
        type: typeAlert,
        message: responseJSON.data
      });
    })
    .always(function() {
      nifty.body.overlay('hide');
    })
}

/**
 * Forçar o Donwload do Arquivo
 *
 * @param  {string} link
 *
 * @return {void}
 */
function forceDownload(link) {
  const file = fileName(link);
  const buttonDownload = document.querySelector(`[data-id="${file}"]`);
  buttonDownload.click();
}

function fileName(link) {
  const partsLink = link.split('/');
  const fileName = partsLink[partsLink.length - 1];
  return fileName.split('.')[0];
}

/**
 * Enviar a request com a busca dos dados
 *
 * @param  {element} form
 *
 * @return {response}
 */
function sendRequestFilter(form) {
  const periodoContabilElement = document.querySelector('#periodoContabil');
  const dataInicial = document.querySelector('#dataInicial');
  const dataFinal = document.querySelector('#dataFinal');
  const usuariosElement = document.getElementById('usuarios');
  const dataDocumento = document.getElementById('dataDocumento');
  const reembolsavel = document.getElementById('reembolsavel');

  const data = {};

  // Se existir data inicial, pega o valor definido nela
  if (document.body.contains(dataInicial)) {
    data.dataInicial = dataInicial.value;
  }

  // Se existir data final, pega o valor definido nela
  if (document.body.contains(dataFinal)) {
    data.dataFinal = dataFinal.value;
  }

  // se existir o element periodoContabil. adiciona
  // o valor dele ao objeto data
  if (document.body.contains(periodoContabilElement)) {
    data.periodoContabil = periodoContabilElement.value;
  }

  // se existir o elemento usuarios,
  // adiciona o valor dele ao data
  if (document.body.contains(usuariosElement)) {
    data.usuarios = usuariosElement.selectize.getValue();
  }

  // se existir o elemento dataDocumento,
  // adiciona o valor dele ao data
  if (document.body.contains(dataDocumento)) {
    data.dataDocumento = dataDocumento.value;
  }

  // adicionando o filtro de reembolsável se ele existir
  // na tela
  if (document.body.contains(reembolsavel)) {
    data.reembolsavel = reembolsavel.value;
  }

  return $.ajax({
    method: 'POST',
    url: form.action,
    data
  });
}

module.exports = {
  init: ExportarIntegracao,
  url: /^\/admin\/integracoes/,
};
